import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useRestaurantNav } from '../../hooks/useRestaurantNav';
import { useDispatch, useSelector } from 'react-redux';
import { triggerWorkflowRequest } from '../../redux/slices/workflowTriggerSlice';
import type { RootState } from '../../redux/store';

const GetStarted: React.FC = () => {
  const { navigate } = useRestaurantNav();
  const dispatch = useDispatch();
  
  const { loading, success, message } = useSelector((state: RootState) => state.workflowTrigger);
  const restaurantId = useSelector((state: RootState) => state.clover.restaurantId);

  useEffect(() => {
    // Check if workflow completed successfully
    if (success && message === 'Already Ran for this restaurant') {
      // Navigate to dashboard
      navigate('/dashboard');
    } else if (success && message !== 'Already Ran for this restaurant') {
      // Navigate to processing page
      navigate('/processing');
    }
  }, [success, message, navigate]);

  const handleGenerate = () => {
    if (!restaurantId) return;
    
    dispatch(triggerWorkflowRequest({ restaurantId }));
  };


  return (
    <div className="min-h-screen bg- flex items-center justify-center p-6"
    style={{
                  backdropFilter: 'blur(10px)',
                  boxShadow: '0 0 14px 0 #0000001a',
                  background: '#212121',
                  border: '1px solid #e0e0e021'
                }}>
      <div className="max-w-2xl w-full grid  gap-12 items-center">
        {/* Left Side - Image */}
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.3 }}
          className="flex flex-col justify-center items-center"
        >
          <img
            src="/assets/images/drawer/campaign.png" 
            alt="Get Started"
            className="w-full text-center max-w-sm"
          />

           <p className="text-gray-400 text-[13px] text-center mt-2 leading-relaxed mb-8">
            PromoFlowAI is the AI marketing suite that keeps your restaurant visible and relevant. It delivers campaign ideas, competitor analysis, and menu/combo promotion suggestions powered by nearby-event signals. Create posters instantly, publish across channels, and track performance to drive more orders.
          </p>

          {/* Generate Button */}
          <motion.button
            onClick={handleGenerate}
            disabled={loading}
            className={`px-8 mt- py-2 italic text-white text-lg font-normal rounded-full shadow-lg transition-all ${
              loading 
                ? 'bg-gray-600 cursor-not-allowed' 
                : 'bg-[#EE4423] hover:bg-[#d63d20] cursor-pointer'
            }`}
          >
            {loading ? 'Generating...' : 'Generate Now'}
          </motion.button>
        </motion.div>
      </div>
    </div>
  );
};

export default GetStarted;
